import React, {useState} from "react";
import {Button, InlineStack, Box, Text} from "@shopify/polaris";

function ToggleSwitch({value,onChangeFn}) {

    return (
        <InlineStack>
            <Box className={`toggle-switch ${value ? "yes" : "no"}`} onClick={onChangeFn}>
                <div className="toggle-circle"/>
            </Box>
        </InlineStack>
    );
}

export default ToggleSwitch;
